import { render, staticRenderFns } from "./AxNotFound.vue?vue&type=template&id=ee6c1804"
import script from "./AxNotFound.vue?vue&type=script&lang=ts"
export * from "./AxNotFound.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports